import { render, staticRenderFns } from "./customer-transaction-history.vue?vue&type=template&id=0ff20dd2"
import script from "./customer-transaction-history.vue?vue&type=script&lang=js"
export * from "./customer-transaction-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports